export const MAX_EXPORT_RECORDS = 10000;
export const EXPORT_PAGE_SIZE = 100;

export const getDisplayFileType = (record) => {
  if (record.itemType === 'folder') {
    return 'other';
  }

  const fileName = record.fileName || record.fullPath?.split('/').pop() || '';
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex <= 0 || dotIndex === fileName.length - 1) {
    return 'other';
  }

  return fileName.slice(dotIndex + 1).toLowerCase();
};

export const formatTimestampForExport = (dateString) => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }

    const datePart = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    const timePart = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });

    return `${datePart} ${timePart}`;
  } catch (err) {
    return 'Invalid Date';
  }
};

export const formatLiveUrlsForExport = (liveUrls) => {
  if (!liveUrls?.standard) {
    if (liveUrls?.curriculum) {
      return liveUrls.curriculum;
    }
    return 'N/A';
  }

  if (liveUrls.curriculum) {
    return `${liveUrls.standard}\n${liveUrls.curriculum}`;
  }

  return liveUrls.standard;
};

export const mapRecordToExportRow = (record) => ({
  Timestamp: formatTimestampForExport(record.pushedAt),
  'Root Folder': record.rootFolder || '',
  'File Path': record.fullPath || '',
  'File Type': getDisplayFileType(record),
  'Item Type': record.itemType || '',
  'Pushed By': record.pushedBy || '',
  'Live URL': formatLiveUrlsForExport(record.liveUrls)
});

const getTimestamp = () => {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
};

const hasActiveFilters = (filters = {}) => (
  (Array.isArray(filters.rootFolder) && filters.rootFolder.length > 0)
  || Boolean(filters.pushedBy)
  || Boolean(filters.dateFrom)
  || Boolean(filters.dateTo)
  || (Array.isArray(filters.fileType) && filters.fileType.length > 0)
);

export const buildExportFilename = (filters = {}) => {
  const base = `LiveUrlTracking_${getTimestamp()}`;
  const rootFolders = filters.rootFolder;

  if (Array.isArray(rootFolders) && rootFolders.length === 1) {
    const safe = rootFolders[0].replace(/[^a-zA-Z0-9_-]/g, '_');
    return `${base}_${safe}.xlsx`;
  }

  if (hasActiveFilters(filters)) {
    return `${base}_filtered.xlsx`;
  }

  return `${base}.xlsx`;
};
